import React from "react";

export default function Marker() {
  return (
    <div className="marker">
      <div className="marker-body" />
      <div className="marker-cap" />
    </div>
  );
}
